import type {CSSProperties} from 'react'

type LanguageColorDotProps = {
  color?: string
  size?: number
  marginRight?: string
}

export const LanguageColorDot = ({color = '#586069', size = 8, marginRight = '3px'}: LanguageColorDotProps) => {
  const style: CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: color,
    display: 'inline-block',
    marginRight,
  }

  return <span style={style} />
}

try{ LanguageColorDot.displayName ||= 'LanguageColorDot' } catch {}